import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../../../../components/ui/select";
import { useConnectStore } from "@/dentlab/src/store/Connect";

export const ConnectRelationshipVendorSelect: React.FC<{
	onSelect: (vendorOrgId: string) => void;
}> = ({ onSelect }) => {

	const { connectedVendors, brandsByOrgId } = useConnectStore((state) => ({
		connectedVendors: state.connectedVendors,
		brandsByOrgId: state.brandsByOrgId,
	}));

	const connectRelationshipsVendors: {
		label: string;
		value: string;
	}[] = connectedVendors.map((vendor) => ({
		label: brandsByOrgId[vendor]?.name ?? "",
		value: vendor,
	}));

	return (
		<Select onValueChange={onSelect}>
			<SelectTrigger className="w-full">
				<SelectValue placeholder="Verbindung auswählen" />
			</SelectTrigger>
			<SelectContent className="z-[1400]">
				{connectRelationshipsVendors.map((option) => (
					<SelectItem key={option.value} value={option.value}>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
